import { useUserStore } from '~/stores/user'
import { useAuthData } from './useAuthData'

export function useInit() {
  const userStore = useUserStore()
  const { fetchUserSubscription, refreshUserInfo } = useAuthData()

  // 更新用户订阅信息
  const updateUserSubscription = async (userId: string) => {
    try {
      const { subscription, status } = await fetchUserSubscription(userId)
      userStore.setSubscription(subscription)
      userStore.setSubscriptionStatus(status)
    }
    catch (error) {
      console.error('Failed to update user subscription:', error)
    }
  }

  // 初始化应用状态
  const initializeApp = async () => {
    try {
      // 首先初始化认证状态
      await userStore.initializeAuth()

      // 如果用户已登录，获取订阅信息
      if (userStore.user?.id) {
        await updateUserSubscription(userStore.user.id)
      }
    }
    catch (error) {
      console.error('Failed to initialize app:', error)
    }
  }

  // 刷新用户信息
  const refreshUser = async () => {
    try {
      const user = await refreshUserInfo()
      if (user) {
        userStore.setUser(user)
      }
    }
    catch (error) {
      console.error('Failed to refresh user:', error)
    }
  }

  // 刷新订阅信息
  const refreshSubscription = async () => {
    if (userStore.user?.id) {
      await updateUserSubscription(userStore.user.id)
    }
  }

  // 处理登录成功后的操作
  const onLoginSuccess = async (userId: string) => {
    await updateUserSubscription(userId)
  }

  return {
    // 应用初始化
    initializeApp,

    // 订阅管理
    updateUserSubscription,
    refreshSubscription,

    // 用户信息管理
    refreshUser,

    // 登录后处理
    onLoginSuccess,
  }
}
